var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaymentVerification(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Payment_Verification",
    "data-name": "Payment Verification",
    transform: "translate(-79 -228)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base",
    width: 24,
    height: 24,
    transform: "translate(79 228)",
    fill: "rgba(255,255,255,0.5)",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "money",
    transform: "translate(79.965 147.019)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3201",
    "data-name": "Path 3201",
    d: "M35.581,155.4h4.027v1.289H35.581Z",
    transform: "translate(-34.052 -66.739)",
    fill: "rgba(255,255,255,0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3202",
    "data-name": "Path 3202",
    d: "M35.581,326.6h4.027v1.289H35.581Z",
    transform: "translate(-34.052 -230.586)",
    fill: "rgba(255,255,255,0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3203",
    "data-name": "Path 3203",
    d: "M0,241H5.556v1.289H0Z",
    transform: "translate(0 -148.662)",
    fill: "rgba(255,255,255,0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3204",
    "data-name": "Path 3204",
    d: "M178.645,85.663a7.319,7.319,0,1,0,7.319,7.319A7.327,7.327,0,0,0,178.645,85.663Zm0,6.675a2.014,2.014,0,0,1,.645,3.922v1.048H178V96.259a2.017,2.017,0,0,1-1.369-1.908h1.289a.725.725,0,1,0,.725-.725A2.014,2.014,0,0,1,178,89.705V88.658h1.289v1.048a2.017,2.017,0,0,1,1.369,1.908H179.37a.725.725,0,1,0-.725.725Z",
    transform: "translate(-163.964)",
    fill: "rgba(255,255,255,0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentVerification);
export default __webpack_public_path__ + "static/media/paymentVerification.ee91dfaf3a4935023ba56e6d73731707.svg";
export { ForwardRef as ReactComponent };